"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorage = exports.StorageProvider = exports.defaultsMultiSelect = void 0;
var react_1 = __importStar(require("react"));
// Central default values for storage data
var localProfile = {
    lastVideo: '',
    subtitleId: '',
    audioTrackId: '',
    subtitlePriorityKeywords: ['full', 'dialogue'],
    subtitleSelectionMode: 'default',
    defaultSubtitleLanguages: ['eng'],
    defaultAudioLanguages: ['eng'],
    allowedSubtitleLanguages: ['any'],
    allowedAudioLanguages: ['any'],
    rememberTrackSelection: true,
    showSubTrackLoadedToast: true,
    useMpvForExternalSubtitles: true,
    maxVolume: '130',
};
exports.defaultsMultiSelect = {
    defaultPriorityKeywords: ['full', 'dialogue', 'signs', 'sings', 'songs', 'lyrics'].map(function (keyword) { return ({
        value: keyword,
        label: keyword.charAt(0).toUpperCase() + keyword.slice(1)
    }); }),
    defaultMaxVolume: ['75', '100', '125', '130', '150', '175', '200', '225'].map(function (keyword) { return ({
        value: keyword,
        label: keyword + '%'
    }); }),
    defaultSubSelectionMode: [
        {
            value: 'default',
            label: 'Select Default Subtitle'
        },
        {
            value: 'forced',
            label: 'Select Forced Subtitle'
        },
        {
            value: 'off',
            label: 'Select Disabled'
        }
    ],
};
var StorageContext = (0, react_1.createContext)({});
var StorageProvider = function (_a) {
    var children = _a.children;
    // Initialize the storage state from localStorage or fall back to the default.
    var _b = (0, react_1.useState)(function () {
        try {
            var storedValue = localStorage.getItem('localProfile');
            if (storedValue) {
                var parsed = JSON.parse(storedValue);
                return __assign(__assign({}, localProfile), parsed);
            }
            else {
                return localProfile;
            }
        }
        catch (error) {
            console.error('Error reading from localStorage:', error);
            return localProfile;
        }
    }), storage = _b[0], setStorage = _b[1];
    // Sync the storage state to localStorage on every update.
    (0, react_1.useEffect)(function () {
        try {
            localStorage.setItem('localProfile', JSON.stringify(storage));
        }
        catch (error) {
            console.error('Error saving to localStorage:', error);
        }
    }, [storage]);
    // Helper to update the storage state by merging new values with the existing ones.
    var updateStorage = function (update) {
        setStorage(function (prev) { return (__assign(__assign({}, prev), update)); });
    };
    return (react_1.default.createElement(StorageContext.Provider, { value: { storage: storage, updateStorage: updateStorage } }, children));
};
exports.StorageProvider = StorageProvider;
// Custom hook returning an array so you can use array destructuring.
var useStorage = function () {
    var context = (0, react_1.useContext)(StorageContext);
    if (!context) {
        throw new Error('useStorage must be used within a StorageProvider');
    }
    return [context.storage, context.updateStorage];
};
exports.useStorage = useStorage;
